import React from "react";
import "./Sidebar.scss";

/**
 * Sidebar — Menú lateral genérico y reutilizable.
 *
 * Props:
 *   nav        array      Grupos e ítems de navegación.
 *                         Formato agrupado:  [{ group: "Nombre", items: [{ id, label, icon? }] }]
 *                         Formato plano:     [{ id, label, icon? }]
 *   activeId   string     Id del ítem actualmente activo.
 *   onSelect   function   Callback que recibe el id al hacer clic en un ítem.
 *   brand      node       Contenido del encabezado (ReactNode). Opcional.
 *   width      number     Ancho en px del sidebar. Default: 220.
 *   className  string     Clase extra para el elemento raíz.
 */
const Sidebar = ({ nav = [], activeId, onSelect, brand, width = 220, className = "" }) => {
    // Normaliza: si los elementos no tienen propiedad "items", trata la lista como plana
    const groups = nav.length > 0 && nav[0].items !== undefined
        ? nav
        : [{ group: null, items: nav }];

    return (
        <aside
            className={`Sidebar ${className}`.trim()}
            style={{ width, minWidth: width }}
        >
            {brand && (
                <div className="sidebar-brand">{brand}</div>
            )}

            <nav className="sidebar-nav">
                {groups.map((group, gi) => (
                    <div key={group.group ?? gi} className="sidebar-nav-group">
                        {group.group && (
                            <div className="sidebar-nav-group-label">{group.group}</div>
                        )}
                        {group.items.map(item => (
                            <button
                                key={item.id}
                                className={`sidebar-nav-item ${activeId === item.id ? "active" : ""}`}
                                onClick={() => onSelect?.(item.id)}
                            >
                                {item.icon && (
                                    <span className="icon sidebar-nav-item-icon" data-icon={item.icon} />
                                )}
                                {item.label}
                            </button>
                        ))}
                    </div>
                ))}
            </nav>
        </aside>
    );
};

export default Sidebar;
